import "./SellmodeAuth.scss";
import { LoginLayout } from "../../../layouts";
import { motion } from "framer-motion";
import primaryComponents from "../../../components/primaryComponents";
import secondaryComponents from "../../../components/secondaryComponents";
import { Link } from "react-router-dom";
import SellmodeAuthValidation from "./SellmodeAuthValidation";
import SellModeAuthLogic from "./SellModeAuthLogic";
import { pathConstants } from "../../../routes/pathContants";

const SellmodeAuth = () => {
  const {
    cashierCode,
    businessAccessCode,
    isLogging,
    setCashierCode,
    setBusinessAccessCode,
    cashierlogin,
  } = SellModeAuthLogic();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    trigger,
  } = SellmodeAuthValidation({ businessAccessCode });

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Cahier Log In"
      description="Log in to your sellmode account"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.3 } }}
          exit={{ opacity: 0 }}
        >
          <LoginLayout>
            <form className="sellmode" onSubmit={handleSubmit(cashierlogin)}>
              <h4 className="font-weight-normal">Login To Sell Mode</h4>
              <hr style={{ marginLeft: "-15px", marginRight: "-15px" }} />
              {/* login form section */}
              <div className="mt-4 mb-3">
                <primaryComponents.InputFieldV2
                  control={control}
                  name="businessAccessCode"
                  label="Business Access Code"
                  classNames="white"
                  placeholder="Enter business access code"
                  isRequired={true}
                  value={businessAccessCode}
                  errorMessage={errors.businessAccessCode}
                  onKeyUp={() =>
                    errors.businessAccessCode !== undefined &&
                    trigger("businessAccessCode")
                  }
                  onChange={({ target: { value } }) => {
                    setBusinessAccessCode(value);
                  }}
                  register={register}
                />
              </div>
              <div className="verification__form">
                <p className="small-text-size mb-1">
                  Enter your 4-digit PIN created for you by your admin
                </p>
                <div className="otp_input">
                  <primaryComponents.OtpInputField
                    numOfInputs={4}
                    name={"cashier_code"}
                    onChange={setCashierCode}
                    value={cashierCode}
                    secret={true}
                  />
                </div>
              </div>
              <primaryComponents.Button
                classNames="btn btn--primary cover mt-4"
                loadingText="Logging..."
                type="submit"
                isDisabled={cashierCode?.length < 4 || isLogging}
                isLoading={isLogging}
              >
                Log In
              </primaryComponents.Button>
              <hr style={{ marginLeft: "-15px", marginRight: "-15px" }} />

              <p className="d-flex justify-content-end route mt-3 text-center smallest-text-size">
                Don&apos;t have a 4-digit PIN?
                <Link
                  className="purple--text ml-1 smallest-text-size"
                  to={pathConstants.LOGIN}
                >
                  Login with your password
                </Link>
              </p>
            </form>
          </LoginLayout>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default SellmodeAuth;
